import { GzWizardStepWebComponent } from '../component/GzWizardStepWebComponent';

export interface WizardItem {
  id?: string;
  title: string;
  message: string;
  step: number;
  isOptional?: boolean;
}

export enum Status {
  DEFAULT = 'default',
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
}

export enum WizardEvent {
  SELECTION_CHANGE = 'wizardSelectionChange',
  STEP_STATUS_CHANGE = 'stepStatusChange',
}

/**
 * This event is emitted each time the active step changes, either by navigating with previous/next of by clicking a
 * step
 */
export class WizardSelectionEvent extends CustomEvent<{
  // Index of the currently selected step
  selectedIndex: number;

  // Index of the previously selected step
  previouslySelectedIndex: number;

  // The currently selected step component
  selectedStep: GzWizardStepWebComponent;

  // The previously selected step component
  previouslySelectedStep: GzWizardStepWebComponent;
}> {}

/**
 * This event is emitted every time a step status changes from DEFAULT to COMPLETE or INCOMPLETE
 */
export class WizardStepStatusChangeEvent extends CustomEvent<{
  stepIndex: number;
  stepStatus: Status;
}> {}
